export default Object.freeze({
  ANALYTICS: 'all',
  TRACKED: 'tracked'
})
